module.exports = __webpack_public_path__ + "static/ic_arrow_drop_down_black_24px.77a0c6cb5e56584ab94976853834b18a.svg";